import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import { Card } from '../../Atoms/Card';

const pluralize = (noun, number) => (number === 1 ? noun : `${noun}s`);

const defaultState = 'unable to connect';

const normalizeStateString = (state) => state && state.toLowerCase();

export const getClassNameForState = (state) => {
  const normalizedState = normalizeStateString(state);

  if (normalizedState === 'online') return 'status-online';

  if (['unavailable', 'offline', defaultState].includes(normalizedState)) {
    return 'status-offline';
  }

  return 'status-aged';
};

export const getClassNameForLineState = (lineState) => {
  const normalizedLineState = normalizeStateString(lineState);

  if (normalizedLineState === 'available') return 'status-online';

  if (['unavailable', 'in use'].includes(normalizedLineState)) {
    return 'status-offline';
  }

  return 'status-aged';
};

const PhoneLines = ({ data, ...props }) => {
  const title = pluralize('Phone Line', data?.lines?.length || 2);
  const state = data?.state || defaultState;

  return (
    <Card title={title} {...props}>
      <div className="d-flex flex-column">
        {data && (
          <>
            <div className="bg-gray-100 p-2 text-sm text-uppercase text-center w-100 mb-3">
              Voice status
              <strong
                className={classNames(
                  'ml-2',
                  getClassNameForState(normalizeStateString(state)),
                )}
              >
                {state}
              </strong>
            </div>

            <ul className="pl-0">
              {data.lines.map(({ state: lineState, name }, index) => {
                return (
                  <li
                    key={name}
                    className="d-flex align-items-center justify-content-between mb-3"
                  >
                    <p>
                      Line {index + 1}: <strong>{name}</strong>
                    </p>
                    <strong
                      className={classNames(
                        'text-uppercase',
                        'text-sm',
                        getClassNameForLineState(lineState),
                      )}
                    >
                      {lineState}
                    </strong>
                  </li>
                );
              })}
            </ul>
          </>
        )}

        <p className="text-gray-500">
          <small>
            <em>
              Voicemail Notification:
              <br />
              Fast dial tone pulse on handset indicates a new voicemail message.
            </em>
          </small>
        </p>
      </div>
    </Card>
  );
};

PhoneLines.propTypes = {
  data: PropTypes.shape({
    state: PropTypes.string,
    lines: PropTypes.arrayOf(
      PropTypes.shape({
        state: PropTypes.string,
        name: PropTypes.string.isRequired,
      }),
    ),
  }),
};

export default PhoneLines;
